module.exports = __webpack_public_path__ + "static/media/octocat.ef468e27.png";